var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.416626 10.9725C0.416626 7.27776 0.416626 5.43036 1.13568 4.01914C1.76818 2.77779 2.77742 1.76854 4.01877 1.13605C5.43 0.416992 7.27739 0.416992 10.9722 0.416992H19.0277C22.7225 0.416992 24.5699 0.416992 25.9811 1.13605C27.2225 1.76854 28.2317 2.77779 28.8642 4.01914C29.5833 5.43036 29.5833 7.27776 29.5833 10.9725V19.0281C29.5833 22.7229 29.5833 24.5703 28.8642 25.9815C28.2317 27.2229 27.2225 28.2321 25.9811 28.8646C24.5699 29.5837 22.7225 29.5837 19.0277 29.5837H10.9722C7.27739 29.5837 5.43 29.5837 4.01877 28.8646C2.77742 28.2321 1.76818 27.2229 1.13568 25.9815C0.416626 24.5703 0.416626 22.7229 0.416626 19.0281V10.9725Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61113 15.4166C4.54864 18.4065 3.75 22.7777 3.75 26.4235C3.93519 25.3355 4.78472 22.7846 6.70139 21.2846C9.54862 19.0563 14.7569 19.7904 20.4514 16.0068C26.1459 12.2233 26.7014 7.29156 25.9722 3.50684C25.4656 7.1588 23.7367 8.75039 21.3542 10.1735C16.1806 13.2638 12.9514 12.2221 8.61113 15.4166Z",
    fill: "url(#paint0_linear_861_2734)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61113 15.4166C4.54864 18.4065 3.75 22.7777 3.75 26.4235C3.93519 25.3355 4.78472 22.7846 6.70139 21.2846C9.54862 19.0563 14.7569 19.7904 20.4514 16.0068C26.1459 12.2233 26.7014 7.29156 25.9722 3.50684C25.4656 7.1588 23.7367 8.75039 21.3542 10.1735C16.1806 13.2638 12.9514 12.2221 8.61113 15.4166Z",
    fill: "url(#paint1_linear_861_2734)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79858 24.9291C4.02151 21.6348 5.09116 18.0073 8.61111 15.4166C10.8738 13.7513 12.8345 13.2372 14.9261 12.6888C16.1468 12.3688 17.412 12.0371 18.8079 11.458C18.2986 11.9444 15.8787 13.0798 14.0534 13.8384C12.2328 14.5951 10.3134 15.3928 8.71529 16.4583C5.50884 18.5959 4.20507 22.3151 3.79858 24.9291Z",
    fill: "url(#paint2_linear_861_2734)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79858 24.9291C4.02151 21.6348 5.09116 18.0073 8.61111 15.4166C10.8738 13.7513 12.8345 13.2372 14.9261 12.6888C16.1468 12.3688 17.412 12.0371 18.8079 11.458C18.2986 11.9444 15.8787 13.0798 14.0534 13.8384C12.2328 14.5951 10.3134 15.3928 8.71529 16.4583C5.50884 18.5959 4.20507 22.3151 3.79858 24.9291Z",
    fill: "url(#paint3_linear_861_2734)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5601 13.3035C23.1609 13.6946 22.7157 14.0447 22.2223 14.3408C20 15.6741 17.638 16.1041 15.3397 16.5225C13.5082 16.8559 11.7171 17.182 10.0695 17.9519C6.35445 19.6879 4.06285 23.2986 3.7501 26.4235C3.75008 26.4236 3.75006 26.4238 3.75004 26.4239C3.75003 26.4233 3.75001 26.4228 3.75 26.4222C3.75002 26.1837 3.75346 25.942 3.761 25.6979C3.77993 25.3106 3.81998 24.8814 3.88624 24.4237C4.3767 21.8538 5.71062 18.4619 8.71531 16.4588C9.98727 15.6108 11.4627 14.9324 12.9299 14.3094C14.2201 13.8858 15.383 13.6221 16.4909 13.3709C18.235 12.9755 19.8428 12.611 21.5973 11.7019C25.2786 9.7943 26.2431 5.87425 25.9838 3.56836C26.5343 6.49011 26.3117 10.0837 23.5601 13.3035Z",
    fill: "url(#paint4_linear_861_2734)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5598 13.3037C23.1606 13.6948 22.7154 14.0449 22.2221 14.3409C19.9998 15.6742 17.6378 16.1042 15.3395 16.5226C13.508 16.856 11.7169 17.1821 10.0693 17.952C7.93277 18.9504 6.26703 20.5688 5.17773 22.3583C6.13887 21.0078 7.60308 19.499 9.40956 18.9242C11.1723 18.3634 12.8537 18.3054 14.6005 18.2452C15.1012 18.2279 15.6072 18.2105 16.1221 18.181C17.5097 17.6759 18.9638 16.9958 20.4512 16.0076C21.7332 15.1558 22.7548 14.2457 23.5598 13.3037Z",
    fill: "url(#paint5_linear_861_2734)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5598 13.3037C23.1606 13.6948 22.7154 14.0449 22.2221 14.3409C19.9998 15.6742 17.6378 16.1042 15.3395 16.5226C13.508 16.856 11.7169 17.1821 10.0693 17.952C7.93277 18.9504 6.26703 20.5688 5.17773 22.3583C6.13887 21.0078 7.60308 19.499 9.40956 18.9242C11.1723 18.3634 12.8537 18.3054 14.6005 18.2452C15.1012 18.2279 15.6072 18.2105 16.1221 18.181C17.5097 17.6759 18.9638 16.9958 20.4512 16.0076C21.7332 15.1558 22.7548 14.2457 23.5598 13.3037Z",
    fill: "url(#paint6_linear_861_2734)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.984 3.56774C25.9801 3.54741 25.9763 3.52711 25.9724 3.50684C25.4657 7.1588 23.7368 8.75039 21.3543 10.1735C20.4518 10.7126 19.6084 11.126 18.808 11.458C18.2986 11.9444 15.8788 13.0798 14.0535 13.8384L14.0533 13.8385C13.6818 13.9929 13.3062 14.149 12.9301 14.3087C14.2203 13.8851 15.3831 13.6215 16.491 13.3703C18.2351 12.9749 19.843 12.6104 21.5974 11.7013C25.2787 9.79368 26.2432 5.87364 25.984 3.56774Z",
    fill: "url(#paint7_linear_861_2734)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.984 3.56774C25.9801 3.54741 25.9763 3.52711 25.9724 3.50684C25.4657 7.1588 23.7368 8.75039 21.3543 10.1735C20.4518 10.7126 19.6084 11.126 18.808 11.458C18.2986 11.9444 15.8788 13.0798 14.0535 13.8384L14.0533 13.8385C13.6818 13.9929 13.3062 14.149 12.9301 14.3087C14.2203 13.8851 15.3831 13.6215 16.491 13.3703C18.2351 12.9749 19.843 12.6104 21.5974 11.7013C25.2787 9.79368 26.2432 5.87364 25.984 3.56774Z",
    fill: "url(#paint8_linear_861_2734)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_861_2734",
    x1: 16.4583,
    y1: 17.2916,
    x2: 4.44444,
    y2: 25.9027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602538,
    stopColor: "#FFB915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFC41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_861_2734",
    x1: 11.7014,
    y1: 18.0207,
    x2: 11.7708,
    y2: 19.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_861_2734",
    x1: 18.8194,
    y1: 10.8333,
    x2: 1.87499,
    y2: 25.9027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005FC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279756,
    stopColor: "#23A4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465158,
    stopColor: "#3AC2B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640642,
    stopColor: "#60EC7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818668,
    stopColor: "#CFFDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0FCB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_861_2734",
    x1: 15.3819,
    y1: 13.7152,
    x2: 13.9236,
    y2: 12.3958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#067EEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_861_2734",
    x1: 26.0417,
    y1: 3.54217,
    x2: 3.75,
    y2: 26.3894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E55F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140795,
    stopColor: "#8B48DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274905,
    stopColor: "#E04DD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492309,
    stopColor: "#F496C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633104,
    stopColor: "#FAD2BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856964,
    stopColor: "#FEF7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_861_2734",
    x1: 23.8539,
    y1: 13.0909,
    x2: 5.6595,
    y2: 21.3201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F41A73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399909,
    stopColor: "#FC50A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584511,
    stopColor: "#FE9485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703104,
    stopColor: "#FFAF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_861_2734",
    x1: 17.2914,
    y1: 15.6256,
    x2: 17.3262,
    y2: 17.2923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B0008"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA115A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_861_2734",
    x1: 26.0418,
    y1: 5.41656,
    x2: 9.6182,
    y2: 16.1457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362865,
    stopColor: "#7053C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466353,
    stopColor: "#7272DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634311,
    stopColor: "#399EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_861_2734",
    x1: 21.9446,
    y1: 10.8332,
    x2: 22.6738,
    y2: 11.7707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F259D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#412DAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcreate);
export default __webpack_public_path__ + "static/media/procreate.a07429ba9dc4506b854da2cf0ff9a326.svg";
export { ForwardRef as ReactComponent };